import { ETypeSearchCommonFranchise } from '@/constant';
import { formatDate } from '@/utils';

import { ColumnTypes } from '..';
import AssignmentHistoryLayerComponent from './../assignment-history-layer';

export const initialValues = {
	searchType: ETypeSearchCommonFranchise.RECRUITER_NAME,
	searchValue: '',
};

export const getColumns = (): ColumnTypes => [
	{
		title: `ID`,
		dataIndex: 'id',
		key: 'no',
		align: 'center',
	},
	{
		title: '읍/면',
		dataIndex: 'districtName',
		key: 'districtName',
		align: 'center',
	},
	{
		title: '고용주',
		dataIndex: 'employerName',
		key: 'employerName',
		align: 'center',
	},
	{
		title: '사업장 주소',
		dataIndex: 'address',
		key: 'address',
		align: 'center',
	},
	{
		title: '고용주 전화번호',
		dataIndex: 'employerPhone',
		key: 'employerPhone',
		align: 'center',
	},
	{
		title: '배정이력',
		dataIndex: 'additionalAssignmentApplicant',
		key: 'additionalAssignmentApplicant',
		align: 'center',
		render: (value: string, record: any) => (
			<AssignmentHistoryLayerComponent id={record?.id} />
		),
	},
	{
		title: '등록일',
		dataIndex: 'registDt',
		key: 'registDt',
		align: 'center',
		render: (value: string) => formatDate(value),
	},
];

// TODO
export const data = Array.from(Array(20).keys()).map((key: number) => ({
	key: key,
	id: key,
	no: key,
	franchiseName: `franchiseName ${key}`,
	franchiseAddress: `franchiseAddress ${key}`,
	franchisePhone: `franchisePhone ${key}`,
	assignmentHistory: `assignmentHistory ${key}`,
	registrationDate: `registrationDate ${key}`,
}));

export const TYPE_SEARCH_FRANCHISE_OPTIONS = [
	{
		value: 'FRANCHISE_NAME',
		label: '고용주',
	},
	{
		value: 'RECRUITER_NAME',
		label: '사업장',
	},
];
